import { type ActionType, createAction } from 'typesafe-actions';
import { INSUFFICIENT_PERMISSIONS, UNAUTHORIZED_REQUEST } from './action-types';

export const unauthorizedRequest = createAction(UNAUTHORIZED_REQUEST)();
export const insufficientPermissions = createAction(INSUFFICIENT_PERMISSIONS)();
export const missingEntitlement = createAction('entitlements/MISSING_ENTITLEMENT')<Error>();

export type ErrorAction =
  | ActionType<typeof unauthorizedRequest>
  | ActionType<typeof insufficientPermissions>
  | ActionType<typeof missingEntitlement>;
